import React, { useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import { formatNumberWithCommas, formatDate } from "@/utils";
import { originOptions, transmissionOptions, displacementOptions, fuelRateOptions, contractStatusOptions } from "@/constants/selectOptions";
import {
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelQuery,
    useGetCarModelDetailQuery,
    useGetCarClassQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
} from "@/redux/metaApi";

export const ContractDetailInfo = ({
    formData,
    setFormData,
    contract,
    onContractChange,
    handleSearchCar,
    allocation,
    onAllocationChange,
}) => {
    const contractCar = contract?.contractCar;
    const { data: carGubunData } = useGetCarGubunQuery();
    const carGubunOptions =
        carGubunData && carGubunData.data
            ? carGubunData.data.map((item) => ({
                value: item.bgNo,
                label: item.bgName,
            }))
            : [];
    const { data: manufacturerData } = useGetCarManufacturerQuery({ bmNo: null });
    const manufacturerOptions =
        manufacturerData?.data?.map((item) => ({
            value: item.bmNo,
            label: item.bmName,
        })) || [];
    const { data: modelData } = useGetCarModelQuery({ bmNo: contractCar?.bmNo }, { skip: !contractCar?.bmNo });
    const modelOptions =
        modelData?.data?.map((item) => ({
            value: item.boiNo,
            label: item.boiName,
        })) || [];
    const { data: detailModelData } = useGetCarModelDetailQuery({ boiNo: contractCar?.boiNo }, { skip: !contractCar?.boiNo });
    const detailModelOptions =
        detailModelData?.data?.map((item) => ({
            value: item.boNo,
            label: item.boName,
        })) || [];
    const { data: carClassData } = useGetCarClassQuery({ boNo: contractCar?.boiNo }, { skip: !contractCar?.boiNo });
    const carClassOptions =
        carClassData?.data?.map((item) => ({
            value: item.bsNo,
            label: item.bsName,
        })) || [];
    const { data: carTrimData } = useGetCarTrimQuery({ bsNo: contractCar?.bsNo }, { skip: !contractCar?.bsNo });
    const carTrimOptions =
        carTrimData?.data?.map((item) => ({
            value: item.bdNo,
            label: item.bdName,
        })) || [];
    const { data: fuelData } = useGetFuelListQuery();
    const fuelOptions =
        fuelData && fuelData.data
            ? fuelData.data.map((item) => ({
                value: item.bfNo,
                label: item.bfName,
            }))
            : [];

    const handleAllocationChange = (newValues) => {
        const newAllocation = { ...allocation, ...newValues };
        // 두 날짜 모두 설정되어 있으면 날짜 비교 (같은 날짜도 허용하지 않음)
        if (newAllocation.releasedAt && newAllocation.returnedAt) {
            const released = new Date(newAllocation.releasedAt);
            const returned = new Date(newAllocation.returnedAt);
            if (returned <= released) {
                setFormData((prev) => ({
                    ...prev,
                    toastMsg: "반납일시가 배차일시보다 빠르거나 같을 수 없습니다.",
                }));
                return;
            }
        }
        onAllocationChange(newValues);
    };

    useEffect(() => {
        console.log(contract);
    }, [contract]);
    return (
        <>
            {/* 차량번호 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        계약번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="serialNumber"
                            placeholder=""
                            value={contract?.serialNumber || ""}
                            onChange={(e) => onContractChange({ ...contract, serialNumber: e.target.value })}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>계약상태</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={contractStatusOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="계약상태"
                            value={contractStatusOptions.find(opt => opt.value === contract?.contractStatus) || null}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            {/* 차량번호 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차량번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="carNumber"
                            placeholder=""
                            value={contractCar?.carNumber || ""}
                            onChange={(e) => onContractChange({ contractCar: { ...contractCar, carNumber: e.target.value } })}
                            disabled
                        />
                    </div>
                </div>
            </div>
            {/* 모델 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="모델 선택"
                            options={modelOptions}
                            value={modelOptions.find((opt) => opt.value === contractCar?.boiNo)}
                            onChange={(option) =>
                                onContractChange({
                                    contractCar: {
                                        ...contractCar,
                                        boiNo: option.value,
                                        boNo: "",
                                        bsNo: "",
                                        bdNo: "",
                                    },
                                })
                            }
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>배차일시</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <DatePicker
                            locale={ko}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={20}
                            selected={allocation?.releasedAt ? new Date(allocation?.releasedAt) : null}
                            onChange={(date) => handleAllocationChange({ releasedAt: date })}
                            timeInputLabel="시간"
                            showTimeInput
                            dateFormat="yyyy.MM.dd HH:mm"
                            onKeyDown={(e) => e.preventDefault()}
                            shouldCloseOnSelect={false}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>반납일시</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <DatePicker
                            locale={ko}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={20}
                            selected={allocation?.returnedAt ? new Date(allocation?.returnedAt) : null}
                            onChange={(date) => handleAllocationChange({ returnedAt: date })}
                            timeInputLabel="시간"
                            showTimeInput
                            dateFormat="yyyy.MM.dd HH:mm"
                            onKeyDown={(e) => e.preventDefault()}
                            shouldCloseOnSelect={false}
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};
